import React from 'react';
import { ArrowSimpleDownIcon, Button, ButtonType, Popover } from '@bettercomp/ui-components';
import { TenantSelector } from 'components/Controls/TenantSelector';
import cn from './styles.module.scss';

export const TenantButton = () => {
  return (
    <Popover
      content={(
        <div className={cn.tenantSelectorContent}>
          <TenantSelector />
        </div>
      )}
      destroyTooltipOnHide
      trigger="click"
      placement="bottomRight"
      rootClassName={cn.tenantPopover}
    >
      <Button
        type={ButtonType.Icon}
        className={cn.dropdownButton}
        data-testid="tenantSelectButton"
      >
        <ArrowSimpleDownIcon />
      </Button>
    </Popover>
  )
}
